module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_5012.4c70ee24.png";